import React, { Component } from 'react';
import { ContactLiterals } from '../../literals/contact/ContactLiterals';
import { getLiteralsForCulture } from '../../literals/Literals';
import { AppProps } from '../AppState';

export class ContactSent extends Component<AppProps> {
  constructor(props: any)
  {
      super(props);
  }

  render () {
    var literals = getLiteralsForCulture(ContactLiterals, this.props.appState.currentCulture) as any;
    
    return (
      <div>
          <section className="fit theme-dark-gray">
              <div className="row">
                  <div className="form-group col-md-offset-2 col-md-10">
                      <h2>{literals.contactSentLabel}</h2>

                      <p>{literals.contactSentParagraphLabel}</p>

                      <p>{literals.contactGetBackParagraphLabel}</p>
                  </div>
              </div>
          </section>
      </div>
    );
  }
}
